import {ChangeDetectorRef, inject, Injectable} from '@angular/core';
import {GameService} from "../services/game.service";
import {Router} from "@angular/router";
import {PlayResult} from "../model/playResult";
import {Hash} from "../model/hash";
import {ENDZONE_OFF_INDEX, getDistance, getYardIndex, TD,} from "../helpers/distance";
import {SelectGainComponent} from "../components/select-gain/select-gain.component";
import {PlayType} from "../model/playType";
import {MatDialog} from "@angular/material/dialog";
import {PenaltyComponent} from "../components/penalty/penalty.component";
import {SetGainCommand} from "../commands/SetGainCommand";
import {SwitchTeamsCommand} from "../commands/SwitchTeamsCommand";
import {changeHashEvent} from "../components/select-hash/select-hash.component";
import {SetHashCommand} from "../commands/SetHashCommand";
import {Command} from "../commands/Command";
import {SetPlayResultCommand} from "../commands/SetPlayResultCommand";
import {SetYardLineCommand} from "../commands/SetYardLineCommand";
import {ODK} from "../model/odk";
import {MatBottomSheet} from "@angular/material/bottom-sheet";
import {GamePlay} from "../model/game-play";
import {SetScoringPlayCommand} from "../commands/SetScoringPlayCommand";
import {SetOdkCommand} from "../commands/SetOdkCommand";
import {SetDownCommand} from "../commands/SetDownCommand";
import {Down} from "../model/down";
import {SetDistanceCommand} from "../commands/SetDistanceCommand";
import {SafetyCommand} from "../commands/SafetyCommand";
import {SetSimpleCommand} from "../commands/SetSimpleCommand";
import {SetPlayTypeCommand} from '../commands/SetPlayTypeCommand';
import { HttpClient } from "@angular/common/http";
import {HomeAway} from "../model/home-away";
import {KickPenaltyDialogOptions, PenaltyDialogOptions} from "../model/penaltyDialog";
import {PenaltyType} from '../model/penaltyType';
import {SetDeadBallPlay} from "../commands/SetDeadBallPlay";
import {PenaltyKickComponent} from "../components/penalty-kick/penalty-kick.component";
import {ResetPenaltyYardsKickoffCommand} from '../commands/ResetPenaltyYardsKickoffCommand';
import {CopyPenaltyYardsKickoffCommand} from '../commands/CopyPenaltyYardsKickoffCommand';
import {SetKickoffYardLineCommand} from '../commands/SetKickoffYardLineCommand';
import {MessageDialogService} from "../services/message-dialog.service";


@Injectable()
export abstract class AbstractGamePlayComponent {
  public game = inject(GameService);
  public messageDialog = inject(MessageDialogService);
  public dialog = inject(MatDialog);
  public router = inject(Router);
  protected _bottomSheet = inject(MatBottomSheet);
  // pour les tests sur les composants dnas les BottomSheet
  public changeDetectorRef = inject(ChangeDetectorRef);
  private http = inject(HttpClient);

  protected readonly Hash = Hash;
  tempCommands: Command[] = []
  result!: PlayResult
  isButtonClicked = [false, false, false, false, false]
  lineUpOffence!: (number)[]
  lineUpDefence!: (number)[]
  lineUpKicking!: (number)[]
  lineUpReturning!: (number)[]
  onsideKickTacklingTeam!: (number)[]
  previousResult: PlayResult = PlayResult.NoPlay


  getPlayLineUp() {
    this.lineUpOffence = (this.game.lineUp[this.game.getPossession(this.game.getFirstPendingGamePlay())]).fullTeam
      .filter(player => player.gamesPlayed[0])
      .map(player => player.gamesPlayed[0].gameJerseyNumber);

    this.lineUpDefence = (this.game.getDefensiveLineUp()).fullTeam
      .filter(player => player.gamesPlayed[0])
      .map(player => player.gamesPlayed[0].gameJerseyNumber);
  }

  /**
   * @returns {Hash} initial du gamePlay en cours.
   *
   * Attention, dès que l'utilisateur change le hash, ceci ajoute une commande setHashCommand
   * qui ne correspondra plus à la valeur de getInitialCurrentHash()
   */
  getCurrentGamePlayInitialHash() {
    return this.game.getFirstPendingGamePlay().hash
  }

  getKickingOrReturningTeamLineUp() {
    let kicking = HomeAway.Home
    let returning = HomeAway.Away
    let onsideKickTacklingTeam = HomeAway.Home
    const gamePlay = this.game.getFirstPendingGamePlay()
    switch (this.game.getFirstPendingGamePlay().playType) {
      case PlayType.KOREC:
      case PlayType.PuntRec:
      case PlayType.FGBlock:
      case PlayType.ExtraPtBlock:
        kicking = HomeAway.Away
        returning = HomeAway.Home
        break
      case PlayType.Punt:
      case PlayType.KO:
      case PlayType.FG:
      case PlayType.ExtraPt:
        kicking = HomeAway.Home
        returning = HomeAway.Away
        break
      case PlayType.OnsideKickRec:
        if (gamePlay.result === PlayResult.Recovered) {
          returning = HomeAway.Away
          kicking = HomeAway.Away
          onsideKickTacklingTeam = HomeAway.Home
        }else {
          returning = HomeAway.Home
          kicking = HomeAway.Home
          onsideKickTacklingTeam = HomeAway.Away
        }
        break
      case PlayType.OnsideKick:
        if (gamePlay.result === PlayResult.Recovered) {
          returning = HomeAway.Home
          kicking = HomeAway.Home
          onsideKickTacklingTeam = HomeAway.Away
        }else {
          returning = HomeAway.Away
          kicking = HomeAway.Away
          onsideKickTacklingTeam = HomeAway.Home
        }
        break
      default:
        break
    }
    this.lineUpKicking = (this.game.lineUp[kicking]).fullTeam
      .filter(player => player.gamesPlayed[0])
      .map(player => player.gamesPlayed[0].gameJerseyNumber);
    this.lineUpReturning = (this.game.lineUp[returning]).fullTeam
      .filter(player => player.gamesPlayed[0])
      .map(player => player.gamesPlayed[0].gameJerseyNumber);
    this.onsideKickTacklingTeam = (this.game.lineUp[onsideKickTacklingTeam]).fullTeam
      .filter(player => player.gamesPlayed[0])
      .map(player => player.gamesPlayed[0].gameJerseyNumber);
  }

  selectGain(gain: number) {
    this.game.addCommand(
      new SetGainCommand(this.game.getFirstPendingGamePlay(), gain));
  }

  onChangeHash($event: changeHashEvent) {
    this.game.addCommand(
      new SetHashCommand(this.game.getFirstPendingGamePlay(), $event.hash)
    )
  }

  simple(){
    this.result = PlayResult.Simple
    this.game.addCommand(
      new SetSimpleCommand(this.game, this.result, this.http)
    )
  }
  /**
   * Plaquage dans la zone défensive
   */
  safety(playResult: PlayResult) {
    this.result = playResult
  }

  fumble() {
    this.router.navigate(['/game-play/fumble']);
  }

  deadBall() {
    this.result = PlayResult.DeadBall
    this.game.addCommand(
      new SetDeadBallPlay(this.game, this.result)
    )
  }

  touchdown(selectGainCmp: SelectGainComponent, gamePlayResult: PlayResult) {
    this.activateSecondaryButtonWhenClicked(0)
    this.result = gamePlayResult || PlayResult.TD
    selectGainCmp.setYardLineIndex(ENDZONE_OFF_INDEX)
  }

  touchdown2(selectGainCmp: SelectGainComponent) {
    selectGainCmp.setYardLineIndex(ENDZONE_OFF_INDEX)
  }

  activateSecondaryButtonWhenClicked(index: number) {
    const currentState = this.isButtonClicked[index];
    this.isButtonClicked.fill(false);
    this.isButtonClicked[index] = !currentState;
  }
  resetSecondaryButton() {
    this.isButtonClicked = this.isButtonClicked.map(() => false);
  }

  openDialogPenalty(options: PenaltyDialogOptions = {}): void {
    options.finishTagOnClose = options.finishTagOnClose || false;
    options.penaltyType = options.penaltyType || PenaltyType.DuringPlay;
    options.initYardline = options.initYardline || this.game.getFirstPendingGamePlay().yardLine;

    const dialogRef = this.dialog.open(PenaltyComponent, {
      maxWidth: '100vw',
      width: '700px',
      data: options
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.navigateOnClose) {
        this.navigateToNextGamePlay(this.game.getFirstPendingGamePlay())
      }
    });
  }

  openDialogPenaltyKick(options: KickPenaltyDialogOptions): void {
    options.finishTagOnClose = options.finishTagOnClose || false;
    options.penaltyType = options.penaltyType || PenaltyType.DuringPlay;
    options.initYardline = options.initYardline || this.game.getFirstPendingGamePlay().yardLine;

    const dialogRef = this.dialog.open(PenaltyKickComponent, {
      maxWidth: '100vw',
      width: '700px',
      data: options
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.navigateOnClose) {
        this.navigateToNextGamePlay(this.game.getFirstPendingGamePlay())
      }
    });
  }

  setResult(newResult: PlayResult) {
    this.previousResult = this.result;
    this.result = newResult;
  }

  finishTagging() {
    const gamePlay = this.game.getFirstPendingGamePlay();
    const nextGamePlay = this.game.getNextGamePlay();

    switch (this.result) {
      case PlayResult.Safety:
      case PlayResult.RushSafety:
      case PlayResult.SackSafety:
      case PlayResult.PenaltySafety:
      case PlayResult.SafetyReceivingTeam:
      case PlayResult.InterceptionSafety:
        this.game.addCommand([
          new SafetyCommand(gamePlay, nextGamePlay, this.game, this.result, this.http)
        ])
        break
      case PlayResult.CompleteTD:
      case PlayResult.RushTD:
      case PlayResult.NoGoodDefTD:
      case PlayResult.InterceptionDefTD:
      case PlayResult.FumbleDefTD:
      case PlayResult.TD:
      case PlayResult.SackFumbleDefTD:
      case PlayResult.BlockDefTD:
      case PlayResult.OnsideKickAwayTD:
      case PlayResult.OnsideKickHomeTD:
        this.game.addCommand([
          new SetScoringPlayCommand(gamePlay,this.game.game, this.result, this.http, this.game),
        ])
        nextGamePlay.distance = 5
        break
      case PlayResult.Good:
        if (this.isPat(gamePlay) || this.isConversion2Pts(gamePlay) || this.isFG(gamePlay)) {
          this.game.addCommand([
            new SetScoringPlayCommand(gamePlay, this.game.game, this.result, this.http, this.game),
          ])
        }
        break
      case PlayResult.NoGood:
      default:
        break
    }

    if (this.isInterception(gamePlay)) {
      this.game.addCommandsAfterTagging([
        new SetPlayResultCommand(gamePlay, this.result),
        new SetGainCommand(gamePlay, 0),
        new SwitchTeamsCommand(nextGamePlay, gamePlay),
        new SetDownCommand(nextGamePlay, Down.D1),
        new SetDistanceCommand(nextGamePlay, 10)
      ])
      if (this.isTD() || this.isDefTD()) {
        this.game.addCommandsAfterTagging([
          new SetYardLineCommand(nextGamePlay, '5'),
          new SetOdkCommand(nextGamePlay, ODK.Kick),
          new SetDownCommand(nextGamePlay, Down.D0),
          new SetDistanceCommand(nextGamePlay, nextGamePlay.distance)
        ])
      }
    } else if (this.isTD(gamePlay)) {
      const gain = getDistance(gamePlay.yardLine, TD)
      const playType = this.game.getPossession(this.game.getFirstPendingGamePlay()) == HomeAway.Home ? PlayType.ExtraPt : PlayType.ExtraPtBlock
      this.game.addCommandsAfterTagging([
        new SetPlayResultCommand(gamePlay, this.result),
        new SetGainCommand(gamePlay, gain),
        new SetYardLineCommand(nextGamePlay, '5'),
        new SetOdkCommand(nextGamePlay, ODK.Kick),
        new SetPlayTypeCommand(nextGamePlay, playType),
        new SetDownCommand(nextGamePlay, Down.D0),
        new SetDistanceCommand(nextGamePlay, nextGamePlay.distance)
      ])
    } else if (this.isDefTD(gamePlay)) {
      const playType = this.game.getPossession(this.game.getFirstPendingGamePlay()) == HomeAway.Home ? PlayType.ExtraPt : PlayType.ExtraPtBlock
      this.game.addCommandsAfterTagging([
        new SetPlayResultCommand(gamePlay, this.result),
        new SetYardLineCommand(nextGamePlay, '5'),
        new SetOdkCommand(nextGamePlay, ODK.Kick),
        new SetPlayTypeCommand(nextGamePlay, playType),
        new SetDownCommand(nextGamePlay, Down.D0),
        new SetDistanceCommand(nextGamePlay, nextGamePlay.distance)
      ])
    } else if (this.isPat(gamePlay) || this.isConversion2Pts(gamePlay)) {
      if (this.result == PlayResult.Penalty) {
        this.game.addCommandsAfterTagging([
          new SetPlayResultCommand(gamePlay, this.result),
          new SetPlayTypeCommand(nextGamePlay, gamePlay.playType!),
          new SetOdkCommand(nextGamePlay, gamePlay.odk),
          new SetDownCommand(nextGamePlay, Down.D0),
          new CopyPenaltyYardsKickoffCommand(gamePlay, nextGamePlay)
        ])
      } else {
        const playType = this.game.getPossession(this.game.getFirstPendingGamePlay()) == HomeAway.Home ? PlayType.KO : PlayType.KOREC
        this.game.addCommandsAfterTagging([
            new SetPlayResultCommand(gamePlay, this.result),
            new SetKickoffYardLineCommand(gamePlay, nextGamePlay),
            new SetOdkCommand(nextGamePlay, ODK.Kick),
            new SetPlayTypeCommand(nextGamePlay, playType),
            new SetDownCommand(nextGamePlay, Down.D0),
            new SetDistanceCommand(nextGamePlay, 0),
            new ResetPenaltyYardsKickoffCommand(nextGamePlay)
        ])
        if (this.result === PlayResult.Good && this.isConversion2Pts(gamePlay)) {
          this.game.addCommandsAfterTagging([
            new SetGainCommand(gamePlay, 5)
          ])
        }
      }
    }

    this.game.finishTagging(gamePlay)

    this.navigateToNextGamePlay(gamePlay)
  }

  protected navigateToNextGamePlay(gamePlay: GamePlay) {
    if (this.isTD(gamePlay) || this.isDefTD(gamePlay)) {
      this.router.navigate(['/game-play/pat-2pts']);
    } else if (this.isPat(gamePlay) || this.isConversion2Pts(gamePlay) ) {
      if (gamePlay.result === PlayResult.Penalty) {
          this.router.navigate(['/game-play/pat-2pts'], { onSameUrlNavigation: 'reload' })
      } else {
        if (this.game.isGameInOvertime()) {
          this.router.navigate(['/select-play-options-overtime']);
        } else {
          this.router.navigate(['/game-play/kickoff-selection']);
        }
      }
    } else if (this.isPlaySelectionNeeded(gamePlay)) {
      if (this.game.isGameInOvertime()) {
        this.router.navigate(['/select-play-options-overtime']);
      } else {
        this.router.navigate(['/select-play-options']);
      }
    } else {
      this.router.navigate(['/game-play']);
    }
  }

  private isInterception(gamePlay?: GamePlay) {
    const result = gamePlay?.result || this.result
    return [PlayResult.Interception, PlayResult.InterceptionDefTD].includes(result);
  }

  protected isPat(gamePlay?: GamePlay) {
    const result = gamePlay?.playType || this.result
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return [PlayType.ExtraPtBlock, PlayType.ExtraPt].includes(result);
  }

  protected isConversion2Pts(gamePlay?: GamePlay) {
    const result = gamePlay?.playType || this.result
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return [PlayType['2Pt'], PlayType['2PtDefend']].includes(result);
  }

  private isFG(gamePlay?: GamePlay) {
    const result = gamePlay?.playType || this.result
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return [PlayType.FG, PlayType.FGBlock].includes(result);
  }

  private isTD(gamePlay?: GamePlay) {
    const result = gamePlay?.result || this.result
    return [PlayResult.RushTD, PlayResult.CompleteTD, PlayResult.TD,
      PlayResult.OnsideKickAwayTD, PlayResult.OnsideKickHomeTD].includes(result);
  }

  private isDefTD(gamePlay?: GamePlay) {
    const result = gamePlay?.result || this.result
    return [PlayResult.BlockDefTD, PlayResult.FumbleDefTD,
      PlayResult.SackFumbleDefTD, PlayResult.InterceptionDefTD, PlayResult.NoGoodDefTD].includes(result);
  }

  private isPlaySelectionNeeded(gamePlay?: GamePlay) {
    const result = gamePlay?.result || this.result
    return [PlayResult.Good].includes(result) && this.isFG(gamePlay);
  }

  isValidGamePlay(): boolean {
    let valid = true
    const message: string[] = []
    valid = this.validation(valid, message);

    if (valid) {
      return true
    }

    this.messageDialog.openMessage(
      'validation.errorTitle',
      message,
      'app.ok',
      'error',
    )
    return false
  }

  protected isPlayerSelectionValid(player: number | undefined) {
    return !(player === null || player === undefined);
  }

  protected validation(valid: boolean, message: string[]): boolean {
    message.push('validation.gamePlay.validationNeeded')
    return false;
  }

  protected validateHash(valid: boolean, message: any[]) {
    if (!this.hasHash()) {
      valid = false
      message.push('validation.gamePlay.noHash')
    }
    return valid;
  }

  /**
   * @returns `true` si un hash a été sélectionné pour le gameplay en cours.
   * @protected
   */
  protected hasHash() {
    return this.game.hasCommand(SetHashCommand) || this.game.getFirstPendingGamePlay().hash;
  }

  public getHalfDistancePenaltyYards() {
    if (this.isPenaltyRestrictionsNearGoalLineEnabled()) {
      const distanceFromTd = getDistance(this.game.getFirstPendingGamePlay().yardLine, 'TD')

      return distanceFromTd > 1 ? Math.ceil(distanceFromTd / 2) : 0
    }

    return undefined
  }

  public isPenaltyRestrictionsNearGoalLineEnabled() {
    const penaltyHalfDistanceThresholdYardLine = '30'
    const currentIndex = getYardIndex(this.game.getFirstPendingGamePlay().yardLine)

    return currentIndex > getYardIndex(penaltyHalfDistanceThresholdYardLine)
  }
}
